import { Injectable } from '@angular/core';
import { StatiEvento } from 'src/app/model/StatiEvento.enum';
import { AclTipo } from 'src/app/model/AclTipo.enum';
import { StatiSegnalazione } from 'src/app/model/StatiSegnalazione.enum';
import { StatiIntervento } from '../components/elenco-interventi/elenco-interventi.component';
import { DialogService } from './dialog.service';
import { AlertsCenterService } from '../core/services/alerts-center.service';
import { SegnalazioniService } from './segnalazioni.service';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SegnalazioneEditabileService {
  private modificatoStato: Subject<string>;
  public modificatoStatoObservable: Observable<string>;

  private sendFlRettificata: Subject<string>;
  public sendFlRettificataObservable: Observable<string>;

  constructor(
    private dialogSvc: DialogService,
    private alertsCenterService: AlertsCenterService,
    private segnalazioniService: SegnalazioniService
  ) {
    this.modificatoStato = new Subject<string>(),
      this.modificatoStatoObservable = this.modificatoStato.asObservable();

    this.sendFlRettificata = new Subject<string>(),
      this.sendFlRettificataObservable = this.sendFlRettificata.asObservable();
  }

  // isEditable(acl: string, statoIntervento: string, statoEvento: string, statoSegnalazione: string): {canDpcplUpdate: boolean, canUpdate: boolean} {
  //   //Il primo valore indica se è editabile, il secondo se è editabile dal dpcpl
  //   let oRet: {canDpcplUpdate: boolean, canUpdate: boolean} = {canDpcplUpdate: false, canUpdate: false};

  //   if (acl === AclTipo.DPCPL) {
  //     let vettStatiEvento: StatiEvento[] = [
  //       StatiEvento.POST_EMERGENZA,
  //       StatiEvento.RACCOLTA_DATI_PE,
  //     ]
  //     let canDpcplUpdate = true;
  //     vettStatiEvento.forEach(stato => {
  //       if (statoEvento === stato) {
  //         canDpcplUpdate = false;
  //       }
  //     })
  //     oRet.canDpcplUpdate  = canDpcplUpdate;
  //   }

  //   // Aggiunta attesa emergenza per caso correzioni
  //   if (statoEvento === StatiEvento.RACCOLTA_DATI || statoEvento === StatiEvento.RACCOLTA_DATI_PE || statoEvento === StatiEvento.ATTESA_EMERGENZA) {
  //     //unici stati editabili
  //     if (statoSegnalazione == StatiSegnalazione.APERTA_PE ||
  //       statoSegnalazione == StatiSegnalazione.IN_BOZZA ||
  //       statoSegnalazione == StatiSegnalazione.COMPLETATA ||
  //       statoSegnalazione == StatiSegnalazione.IN_BOZZA_PE ||
  //       statoSegnalazione == StatiSegnalazione.COMPLETATA_PE) {

  //       if (statoIntervento !== '') {

  //         if (!(statoIntervento == StatiIntervento.IN_ATTESA_DI_FINANZIAMENTO ||
  //           statoIntervento == StatiIntervento.RESPINTO ||
  //           statoIntervento == StatiIntervento.PREVENTIVAMENTE_RESPINTO ||
  //           statoIntervento == StatiIntervento.IN_PROPOSTA_DI_FINANZIAMENTO ||
  //           statoIntervento == StatiIntervento.ESPUNTO)) {
  //           oRet.canUpdate = true;
  //           return oRet;
  //         }
  //         else {
  //           oRet.canUpdate = false;
  //           return oRet;
  //         }

  //       }
  //       else {
  //         oRet.canUpdate = true;
  //         return oRet;
  //       }

  //     }
  //     else {
  //       oRet.canUpdate = false;
  //       return oRet;
  //     }
  //   }
  //   else {
  //     oRet.canUpdate = false;
  //     return oRet;
  //   }
  // }

  changeStatoSegnalazione(acl: string, azioneCambioStato: string, idSegnalazione: number, statoSegnalazione: string, statoIntervento?: string) {
    let statoRicevuto;
    let messageStatus;
    let title;
    let message;
    let segnalazioneDto: ModelEventiCalamitosi.SegnalazioneStatusDTO | undefined;
    ({ title, message, segnalazioneDto, statoRicevuto, messageStatus } = this.valorizzazioneMessaggi(acl, azioneCambioStato, idSegnalazione, statoSegnalazione, statoIntervento));

    // Caso rifiuto segnalazione, devo aggiungere motivazione rifiuto
    if (azioneCambioStato == 'rifiutare') {
      this.dialogSvc.openMotivazioneRifiutoDialog(title, message, true, 'Motivazione rifiuto').subscribe((res: string) => {
          // 'res' è la stringa JSON inviata dal dialog
          if (res && res !== '') {
              // Eseguo il "parsing" della stringa per riottenere l'oggetto.
              const data: { motivazione: string, inAttesaChiarimenti: boolean } = JSON.parse(res);
              segnalazioneDto.motivazioneRifiuto = data.motivazione;
              segnalazioneDto.flagRichiestaIntegrazione = data.inAttesaChiarimenti;

              this.segnalazioniService.changeStatusSegnalazione(segnalazioneDto).subscribe(
                subRes => {
                  const message = data.inAttesaChiarimenti
                    ? 'Segnalazione in richiesta di integrazione'
                    : 'Segnalazione rifiutata con successo';
                  this.alertsCenterService.showAlert({
                    message: message,
                    type: 'success',
                    autoClosable: false
                  });
                  this.modificatoStato.next(statoRicevuto);
                },
                err => {
                  this.alertsCenterService.showAlert({
                    message: err.error.esitoServizio.descrizioneEsito,
                    type: 'danger',
                    autoClosable: false
                  });
                });
          }
      });
    }
    else {
      this.dialogSvc.openDialog(title, message).subscribe(
        result => {
          let confirmed = `${result}`;
          if (confirmed == "true") {
            //CASO COMPLETATA
            if (azioneCambioStato == 'completare') {
              this.alertsCenterService.showAlert({
                message: 'Stato segnalazione non previsto',
                type: 'danger',
                autoClosable: false
              });
            }
            else {
              this.segnalazioniService.changeStatusSegnalazione(segnalazioneDto).subscribe(
                res => {
                  this.alertsCenterService.showAlert({
                    message: messageStatus,
                    type: 'success',
                    autoClosable: false
                  });
                  this.modificatoStato.next(statoRicevuto);
                  // Se la chiamata è andata bene la segnalazione
                  // torna in bozza ed fl_rettificata = 'S', avviso il componente
                  // dettaglio che deve aggiornare il flag
                  // Questo flag viene emesso SOLO QUANDO una segnalazione RIF viene riaperta
                  if (azioneCambioStato === 'correzione') this.sendFlRettificata.next('S');
                },
                err => {
                  this.alertsCenterService.showAlert({
                    message: err.error.esitoServizio.descrizioneEsito,
                    type: 'danger',
                    autoClosable: false
                  });
                });
            }
          }
        }
      );
    }
  }

  valorizzazioneMessaggi(acl: string, stato: string, idSegnalazione: number, statoSegnalazione: string, statoIntervento?: string) {
    let messageStatus: string;
    let statoRicevuto: string = '';
    if (stato == 'validare') {
      statoRicevuto = acl === AclTipo.DPCPL ? StatiSegnalazione.RICEVUTA : StatiSegnalazione.RICEVUTA_PE;
      messageStatus = "Segnalazione validata con successo";
    } else if (stato == 'completare') {
      statoRicevuto = statoSegnalazione === StatiSegnalazione.IN_BOZZA ? StatiSegnalazione.COMPLETATA : StatiSegnalazione.COMPLETATA_PE;
      messageStatus = "Segnalazione confermata con successo";
    } else if (stato == 'rifiutare') {
      statoRicevuto = acl === AclTipo.DPCPL ? StatiSegnalazione.RIFIUTATA : StatiSegnalazione.RIFIUTATA_PE;
      //messageStatus NON va settato qui perché flag non è ancora disponibile
    } else if (stato == 'confermare') {
      statoRicevuto = acl === AclTipo.DPCPL ? StatiSegnalazione.CONFERMATA : StatiSegnalazione.CONFERMATA_PE;
      messageStatus = "Segnalazione confermata con successo";
    }
    else if (stato == 'correzione') {
      if (statoSegnalazione == StatiSegnalazione.RIFIUTATA) statoRicevuto = StatiSegnalazione.IN_BOZZA
      else if (statoSegnalazione == StatiSegnalazione.RIFIUTATA_PE) {
        if (statoIntervento && statoIntervento != '') statoRicevuto = StatiSegnalazione.APERTA_PE
        else statoRicevuto = StatiSegnalazione.IN_BOZZA_PE
      }
      messageStatus = "Apertura correzione segnalazione avvenuta con successo";
    } else if (stato == 'nonricezione') {
      statoRicevuto = StatiSegnalazione.NON_RICEVUTA;
      messageStatus = "Segnalazione non ricevuta con successo";
    }
    let segnalazioneDto: ModelEventiCalamitosi.SegnalazioneStatusDTO = {
      idDatiRaccolti: idSegnalazione ? idSegnalazione : null,
      idEnte: 0,
      stato: statoRicevuto,
      flagRichiestaIntegrazione: false
    };
    let title = this.capitalizeFirstLetter(stato) + " " + 'segnalazione';
    let message = "Vuoi davvero" + " " + stato + " " + "questa segnalazione?";

    if (stato == 'correzione') {
      title = 'Correzione segnalazione';
      message = "La segnalazione verrà riportata in bozza.<br>L'operazione permetterà di correggere la segnalazione.<br>Vuoi procedere con l'operazione?"
    }

    if (stato == 'rifiutare') {
      message = "Aggiungere una motivazione e confermare per procedere con il rifiuto della segnalazione"
    }

    if (stato == 'validare') {
      title = 'Conferma ricezione segnalazione';
      message = "Confermi di aver ricevuto la segnalazione?";
    }

    if (stato == 'nonricezione') {
      title = 'Conferma non ricezione segnalazione';
      message = "Dopo la non ricezione non sarà più possibile modificare la segnalazione.<br><br>Confermi di non ricevere la segnalazione?";
    }

    return { title, message, segnalazioneDto, statoRicevuto, messageStatus };
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  public isRifiutabile(acl: String, statoSegnalazione: string, abilitazioniPerSegnalazione: { canDgpeUpdate: boolean, canDpcplUpdate: boolean, canUpdate: boolean }) {
    if (acl === AclTipo.DPCPL) {
      return statoSegnalazione == StatiSegnalazione.RICEVUTA && abilitazioniPerSegnalazione.canDpcplUpdate;
    } else {
      return statoSegnalazione == StatiSegnalazione.RICEVUTA_PE && abilitazioniPerSegnalazione.canDgpeUpdate;
    }
  }

  public isNonRicevuta(acl: String, statoSegnalazione: string, abilitazioniPerSegnalazione: { canDgpeUpdate: boolean, canDpcplUpdate: boolean, canUpdate: boolean }) {
    if (acl == AclTipo.DPCPL) {
      return (statoSegnalazione == StatiSegnalazione.INVIATA) && abilitazioniPerSegnalazione.canDpcplUpdate;
    } else
      return (statoSegnalazione == StatiSegnalazione.INVIATA_PE) && abilitazioniPerSegnalazione.canDgpeUpdate;
  }

  public isRicevibile(acl: String, statoSegnalazione: string, abilitazioniPerSegnalazione: { canDgpeUpdate: boolean, canDpcplUpdate: boolean, canUpdate: boolean }) {
    if (acl == AclTipo.DPCPL) {
      return statoSegnalazione == StatiSegnalazione.INVIATA && abilitazioniPerSegnalazione.canDpcplUpdate;
    } else
      return statoSegnalazione == StatiSegnalazione.INVIATA_PE && abilitazioniPerSegnalazione.canDgpeUpdate;
  }

  public isConfermabile(acl: String, statoSegnalazione: string, abilitazioniPerSegnalazione: { canDgpeUpdate: boolean, canDpcplUpdate: boolean, canUpdate: boolean }) {
    if (acl == AclTipo.DPCPL) {
      return statoSegnalazione == StatiSegnalazione.RICEVUTA && abilitazioniPerSegnalazione.canDpcplUpdate;
    } else
      return statoSegnalazione == StatiSegnalazione.RICEVUTA_PE && abilitazioniPerSegnalazione.canDgpeUpdate;;
  }

  // Metodo di controllo per verificare se una segnalazione è nello stato opportuno per essere riaperta
  public isRiapribile(acl: String, statoSegnalazione: string, statoEvento: string, apertaCorrezionePerUtente: boolean) {
    if (acl == AclTipo.EELL) {
      switch (statoEvento) {
        case StatiEvento.RACCOLTA_DATI:
          return (statoSegnalazione == StatiSegnalazione.RIFIUTATA && apertaCorrezionePerUtente);
        case StatiEvento.RACCOLTA_DATI_PE:
          return (statoSegnalazione == StatiSegnalazione.RIFIUTATA_PE && apertaCorrezionePerUtente);
        default:
          break;
      }
    }
    else return false
  }


  public isConfermabileSegnalazione(statoSegnalazione: string, canUpdate: boolean, acl: string) {
    return canUpdate && acl == AclTipo.EELL &&
      (statoSegnalazione == StatiSegnalazione.IN_BOZZA ||
        statoSegnalazione == StatiSegnalazione.IN_BOZZA_PE ||
        statoSegnalazione == StatiSegnalazione.APERTA_PE);
  }

  public isEsportabile(statoSegnalazione: string, canUpdate: boolean) {
    return !canUpdate &&
      (statoSegnalazione != StatiSegnalazione.IN_BOZZA);
  }
}
